/**
 * KARIS Luxury Footer
 * Lightweight, dependency-free JS:
 *  - fade-up reveal on scroll (IntersectionObserver)
 *  - mobile accordion for footer columns
 *  - newsletter submit (Shopify customer/newsletter form enhancement)
 *  - auto-submit on change for country / language selectors
 */
(function () {
  "use strict";

  document.querySelectorAll(".luxury-footer").forEach(initFooter);

  function initFooter(footer) {
    initRevealAnimation(footer);
    initAccordion(footer);
    initNewsletter(footer);
    initLocalizationForms(footer);
  }

  /* ---------------------------------------------------------------------- */

  function initRevealAnimation(footer) {
    const targets = footer.querySelectorAll("[data-footer-animate]");
    if (!targets.length) return;

    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );

    targets.forEach((el) => observer.observe(el));
  }

  /* ---------------------------------------------------------------------- */

  function initAccordion(footer) {
    if (footer.getAttribute("data-mobile-accordion") !== "true") return;

    const columns = footer.querySelectorAll('.luxury-footer__block[data-block-type="column"]');

    columns.forEach((col) => {
      const header = col.querySelector(".luxury-footer__block-header");
      const toggle = col.querySelector(".luxury-footer__toggle");
      if (!header || !toggle) return;

      header.setAttribute("role", "button");
      header.setAttribute("tabindex", "0");
      header.setAttribute("aria-expanded", "false");

      const open = () => {
        const isOpen = col.classList.toggle("is-open");
        header.setAttribute("aria-expanded", String(isOpen));
      };

      header.addEventListener("click", () => {
        if (window.matchMedia("(max-width: 749px)").matches) open();
      });

      header.addEventListener("keydown", (e) => {
        if ((e.key === "Enter" || e.key === " ") && window.matchMedia("(max-width: 749px)").matches) {
          e.preventDefault();
          open();
        }
      });
    });
  }

  /* ---------------------------------------------------------------------- */

  function initNewsletter(footer) {
    const forms = footer.querySelectorAll(".luxury-footer__newsletter-form");
    forms.forEach((form) => {
      form.addEventListener("submit", (e) => {
        const input = form.querySelector('input[type="email"]');
        if (input && !input.checkValidity()) {
          e.preventDefault();
          input.reportValidity();
        }
        // Native Shopify /contact#contact_form submit handles the rest;
        // on success Shopify redirects with ?customer_posted=true which
        // section markup already checks server-side to show the message.
      });
    });
  }

  /* ---------------------------------------------------------------------- */

  function initLocalizationForms(footer) {
    footer.querySelectorAll(".footer-localization-form").forEach((form) => {
      const select = form.querySelector(".footer-localization-select");
      if (!select) return;
      select.addEventListener("change", () => {
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    });
  }
})();
